import { IconButton, MenuItem, menuItemClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CallTaskState } from "../../../../call-management.types.js";
const StyledIconButton = styled(IconButton)(({ theme, status }) => ({
  position: "absolute",
  right: 0,
  top: "calc(100% + 8px)",
  fontSize: "18px",
  width: "24px",
  height: "20px",
  borderRadius: "4px",
  background: theme.palette.warning[50],
  color: theme.palette.warning[800],
  ...status === CallTaskState.Ignored && {
    color: theme.palette.grey[600],
    background: theme.palette.grey[200]
  },
  ...(status === CallTaskState.Done || status === CallTaskState.Done_AvailyBooking) && {
    background: theme.palette.success[50],
    color: theme.palette.success[800]
  },
  ...status === CallTaskState.Open_InProgress && {
    background: theme.palette.success[200],
    color: theme.palette.success[900]
  },
  "& svg": {
    fontSize: "24px"
  }
}));
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  ...theme.typography["Lato Caption Bold"],
  background: theme.palette.common.white,
  "&:hover": {
    background: theme.palette.primary["50"]
  },
  [`&.${menuItemClasses.selected}`]: {
    background: theme.palette.common.white,
    "&:hover": {
      background: theme.palette.primary["50"]
    }
  }
}));
const StatusMenuIcon = styled("span")(({ theme, isIgnore }) => ({
  display: "flex",
  borderRadius: "4px",
  padding: "4px",
  fontSize: "14px",
  marginRight: "4px",
  background: theme.palette.secondary[25],
  color: theme.palette.warning[500],
  ...isIgnore && {
    background: theme.palette.grey[300],
    color: theme.palette.grey[600]
  },
  "& svg": {
    fontSize: "14px"
  }
}));
export {
  StatusMenuIcon,
  StyledIconButton,
  StyledMenuItem
};
